import { z } from "zod"

export const territoryLseSchema = z.object({
  /** The territoryId this TerritoryLSE belongs to */
  territoryId: z.number().int(),
  /** The lseId of the LSE offering service in this Territory */
  lseId: z.number().int(),
  /** The name of the LSE */
  lseName: z.string(),
  /** true or false indicating whether this LSE is a distribution LSE */
  distribution: z.boolean().nullable(),
  /** true or false indicating whether this LSE
   * supplies service to residential customers */
  supplierResidential: z.boolean().nullable(),
  /** true or false indicating whether this LSE
   * supplies service to general (commercial and industrial) customers */
  supplierGeneral: z.boolean().nullable(),
  /** Percentage of residential customers this LSE supplies service to */
  residentialCoverage: z.number().nullable(),
  /** Percentage of general (commercial and industrial)
   * customers this LSE supplies service to */
  generalCoverage: z.number().nullable(),
})

export type TerritoryLse = z.infer<typeof territoryLseSchema>
